import { render } from "./NewYearOverlay.vue?vue&type=template&id=0cb80c25&scoped=true"
import script from "./NewYearOverlay.vue?vue&type=script&lang=js"
export * from "./NewYearOverlay.vue?vue&type=script&lang=js"

import "./NewYearOverlay.vue?vue&type=style&index=0&id=0cb80c25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb80c25"]])

export default __exports__